import { apiUrls } from '../api/api-urls'
import { fetchMutation } from '../utils'

export const postForgotPassword = (email: string) =>
  fetchMutation<{ token: string }>(apiUrls.forgotPassword, {
    method: 'POST',
    body: JSON.stringify({ email }),
    headers: { 'Content-Type': 'application/json' },
  })
